// ================================================================================
// script.js
// 案件用のスクリプトファイル
// ================================================================================

// Import
// --------------------------------------------------------------- //
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

//import frontNewsTab from './front-page.js';
import frontScrollBackground from './front-page-scroll.js';
import siteMenu from './site-menu.js';
import dropDownMenu from './dropdown-menu.js';
import linkSyncNone from './link-stync-none.js';
import swiper from './swiper.js';
import career from './career.js';




// DOM Read for Vanilla
// --------------------------------------------------------------- //

document.addEventListener('DOMContentLoaded', () => {

	// breakpoint
	const breakpoint = window.matchMedia( 'screen and (min-width: 960px)' )

	// scroll volume
	function getScrolled() {
		return ( window.pageYOffset !== undefined ) ? window.pageYOffset: document.documentElement.scrollTop;
	}


	// variable
	// --------------------------------------------------------------- //

	// scroll
	let scrollTop = window.pageYOffset;

	// url
	let url = location.href;


	// Functions
	// --------------------------------------------------------------- //

	//frontNewsTab();
	frontScrollBackground();
	siteMenu();
	dropDownMenu();
	linkSyncNone();
	swiper();
	career();


} );

